import React from 'react';
import { Link } from '@reach/router';

function splitUp(arr, n) {
  let rest = arr.length % n; // how much to divide
  let restUsed = rest; // to keep track of the division over the elements
  let partLength = Math.floor(arr.length / n);
  let result = [];

  for(let i = 0; i < arr.length; i += partLength) {
    let end = partLength + i;
    let add = false;

    if(rest !== 0 && restUsed) { // should add one element for the division
      end++;
      restUsed--; // we've used one division element now
      add = true;
    }

    result.push(arr.slice(i, end)); // part of the array

    if(add) {
      i++; // also increment i in the case we added an extra element for division
    }
  }

  return result;
}

const Lawyer = ({ name, image, slug, isActive }) => (<div className={'lawyer' + (isActive ? ' active' : '')}>
  <Link to={`/lawyers/${slug}`}>
    <img src={image} alt="" />
    <span>{name}</span>
  </Link>
</div>);

export default ({ lawyers, active }) => {
  const lawyerGroupings = splitUp(Object.values(lawyers || {}), (active ? 2 : 0));
  return (<div className={active ? 'lawyerGroup isEmbedded' : 'lawyerGroup'}>
    {lawyerGroupings.map((lawyerGroup, lawyerGroupIdx) => <div key={lawyerGroupIdx} className="col-xs-offset-1 col-xs-10 col-sm-offset-1 col-sm-10 col-md-offset-0 col-md-12 col-lg-offset-0 col-lg-12">
      {lawyerGroup.map(lawyer => (
        <Lawyer key={lawyer.slug} {...lawyer} isActive={active === lawyer.slug} />
      ))}
    </div>)}
  </div>);
};
